/**
 * CRM katalógy (stavy, kroky, obchodníci) – non-progressive parita ServiceStateList / startRequest.
 * Úrovne (cust006) nie sú súčasťou tohto vzoru – ostávajú ako ServiceUsersSettings vo FP.
 */

export function filterActiveCrmCatalogRows(rows) {
  return (Array.isArray(rows) ? rows : []).filter((row) => row?.active !== false);
}

export function selectActiveCrmStates(state) {
  return filterActiveCrmCatalogRows(state?.crm_states);
}

export function selectActiveCrmSteps(state) {
  return filterActiveCrmCatalogRows(state?.crm_steps);
}

export function mapCrmTraderRowForList(row) {
  if (!row || typeof row !== 'object') return row;
  return {
    ...row,
    employee_name: row?.user?.employee?.name || '-',
    username: row?.user?.username || '-',
    supervisors_text: (Array.isArray(row?.supervisors) ? row.supervisors : [])
      .map((s) => (s?.employee?.name || s?.username || '').trim())
      .filter(Boolean)
      .join(', '),
  };
}

export function selectCrmTradersListRows(state) {
  return (Array.isArray(state?.crm_traders) ? state.crm_traders : []).map(mapCrmTraderRowForList);
}

export function reloadCrmStatesCatalog(dispatch, getRequest) {
  return getRequest('/api/crm_states').then((resp) => {
    const data = Array.isArray(resp?.data) ? resp.data : [];
    dispatch({ type: 'load_crm_states', newCrmStates: data });
    return data;
  });
}

export function reloadCrmStepsCatalog(dispatch, getRequest) {
  return getRequest('/api/crm_steps').then((resp) => {
    const data = Array.isArray(resp?.data) ? resp.data : [];
    dispatch({ type: 'load_crm_steps', newCrmSteps: data });
    return data;
  });
}

export function reloadCrmTradersCatalog(dispatch, getRequest) {
  return getRequest('/api/crm_traders').then((resp) => {
    const data = Array.isArray(resp?.data) ? resp.data : [];
    dispatch({ type: 'load_crm_traders', newCrmTraders: data });
    return data;
  });
}

let companiesForTicketCache = null;
let companiesForTicketInflight = null;

/** Zdieľaná cache pre filter firiem v CRM/portál listoch. */
export function loadCompaniesForTicketCatalog(getRequest) {
  if (Array.isArray(companiesForTicketCache)) {
    return Promise.resolve(companiesForTicketCache);
  }
  if (!companiesForTicketInflight) {
    companiesForTicketInflight = getRequest('/api/crm_communication_catalog/companies_for_ticket')
      .then((res) => {
        companiesForTicketCache = Array.isArray(res?.data) ? res.data : [];
        return companiesForTicketCache;
      })
      .catch(() => {
        companiesForTicketCache = [];
        return companiesForTicketCache;
      })
      .finally(() => {
        companiesForTicketInflight = null;
      });
  }
  return companiesForTicketInflight;
}
